import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen bg-dark-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <h3 className="text-lg font-semibold text-dark-text mb-2">Verificando autenticação...</h3>
          <p className="text-dark-text-secondary">Aguarde um momento</p>
        </div>
      </div>
    );
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se rota exigir administrador, validar perfil
  if (requireAdmin) {
    const role = user?.role || user?.data?.role;
    const isAdmin =
      role === 'admin' ||
      role === 'master' ||
      (Array.isArray(user?.permissions) && user.permissions.includes('admin'));
    if (!isAdmin) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Se estiver autenticado, renderizar o componente
  return children;
};

export default ProtectedRoute;

